// duplicated from ../bulk_actions.js to avoid jquery issues

// eslint-disable-next-line max-len
// @ts-expect-error - TS7016: Could not find a declaration file for module 'written-number'. 'written-number' implicitly has an 'any' type.
import writtenNumber from 'written-number';
// eslint-disable-next-line max-len
// @ts-expect-error - TS7016: Could not find a declaration file for module 'numbers2words'. 'numbers2words' implicitly has an 'any' type.
import T2W from 'numbers2words';

// @ts-expect-error - TS7006: Parameter number implicitly has an any type.
function convertNumberToWords(number) {
  const T2W_MAPPING = {
    en: 'EN_US',
    de: 'DE_DE',
    id: 'ID_ID',
    cz: 'CS_CZ',
  };

  // @ts-expect-error - TS2339 - Property 'Greenhouse' does not exist on type 'Window & typeof globalThis'.
  const sessionLocale = window.Greenhouse.Translation.locale;
  // @ts-expect-error - TS2538: Type undefined cannot be used as an index type.
  const supportedT2wLocale = T2W_MAPPING[sessionLocale];

  if (supportedT2wLocale) {
    // Throws if unsupported locale provided
    return new T2W(supportedT2wLocale).toWords(number);
  }

  // Defaults to English when locale not found
  // Supports English en,
  // Portuguese (Brazil) pt,
  // Portuguese (Portugal) ptPT,
  // Spanish es,
  // French fr,
  // Esperanto eo,
  // Vietnamese vi,
  // Arabic ar,
  // Azerbaijan az
  // Hungarian hu,
  // Italian it,
  // Turkish tr,
  // English (Indian) enIndian,
  // Ukrainian uk,
  // Indonesian id,
  // Russian ru
  return writtenNumber(number, { lang: sessionLocale });
}

const COUNT_FOR_WARNING = 30;

export { convertNumberToWords, COUNT_FOR_WARNING };
